import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { MainPane, SideColumn } from './IssueEditForm';
import { Form, FormGrid, LoadingIndicator, OccupyFreeSpace, PseudoLink2, SaveButton, SimpleDialog, useSaveable } from '../../toolympus/components/primitives';
import { Button, IconButton, Typography } from '@mui/material';
import { useEditIssue } from './useEditIssue';
import { FormControlsForFields, TableForFields } from '../../toolympus/components/schemed';
import { PlCmsEditor } from '../Administration/PlEditor';
import { useEditIssueContent } from './useEditIssueContent';
import { Add, UploadFileOutlined } from '@mui/icons-material';
import { FieldType } from '../../toolympus/hooks/useSchema';
import { MediaLibPicker, useMediaLibContext } from '../../toolympus/components/medialib';

interface Props {
  
}

export const IssueContentEditForm = (props: Props) => {
  const { id } = useParams<{ id: string }>();
  const data = useEditIssue(+id);
  const items = useEditIssueContent(id);

  const medialib = useMediaLibContext();

  useSaveable(data);

  return (
  
    <Form
      title={`Содержание номера: ${data.data.title || "..."}`}
      fitFullHeight
      headerItems={<>

        <IconButton size="small" color="primary" onClick={() => items.newItem.startEditing({ })}><Add /></IconButton>

        <OccupyFreeSpace />

        {data.isLoading && <LoadingIndicator sizeVariant="s" />}
        {data.hasChanges && <SaveButton action={() => data.save()} />}
        

        <Button size="small" color="primary" startIcon={<UploadFileOutlined />} onClick={() => items.importItems.startEditing({ items_text: "" })}>
          импорт xlsx
        </Button>

        <Link to={`/issues/${id}`} style={{ textDecoration: "none", color: "unset" }}>
          <Button size="small" color="primary">номер</Button>
        </Link>
      </>}>

      <MainPane columns="2fr 1fr" className={""}>
        <TableForFields
          data={items.data}
          fields={[
            ["author"],
            ["is_unlisted_author"],
            ["title"],
            ["subtitle"],
            ["item_format"],
            ["page_nbr"],
            ["page_nbr_display"],
          ]}
          schema={items.schema}
          fieldElement={f => {
            switch(f) {
              case "author":
                return (r,s,o) => <PseudoLink2 onClick={() => items.editItem.startEditing({ ...r })}>{r.author ? o : "..."}</PseudoLink2>
            }
          }}
          />




        <SideColumn>
          <FormGrid columns="1fr" noMargin>
            <FormControlsForFields
              schema={data.schema}
              fields={[
                ["is_public"],
                ["public_title"],
                ["public_subtitle"],
                // ["public_description_x"],
              ]}
              onChange={(o,c) => data.update(c)}
              data={data.data}
              />

            <Typography variant="caption" color="textSecondary">Описание</Typography>
            <PlCmsEditor
              key={data.data._id}
              content={data.data.public_description_x}
              update={v => data.update({ public_description_x: v })}
              />

            <MediaLibPicker
              selectedUrl={data.data.cover_image}
              closeOnSelect
              selectFile={mf => mf ? data.update({ cover_image: medialib.getFilepath(mf) }) : null}
              label="Обложка"

              />
          </FormGrid>
          
        </SideColumn>
      </MainPane>




      <SimpleDialog
        dialogTitle="Добавить"
        noFullscreen
        submitOnModEnter
        {...items.newItem.dialog}
        save={() => items.newItem.save()}
      >
        {!!items.newItem.item &&
          <FormGrid columns="1fr" noMargin>
            <FormControlsForFields
              data={items.newItem.item}
              onChange={(o,c) => items.newItem.update(c)}
              fields={[
                ["author", { controlProps: { autoFocus: true }}],
                ["is_unlisted_author"],
                ["title"],
                ["subtitle"],
                ["item_format"],
                ["page_nbr"],
                ["page_nbr_display"],
              ]}
              schema={items.schema}
              errors={items.newItem.errors}
              />
          </FormGrid>}

      </SimpleDialog>


      <SimpleDialog
        dialogTitle="Редактировать"
        noFullscreen
        submitOnModEnter
        {...items.editItem.dialog}
        save={() => items.editItem.save()}
        simpleExtraActions={<>
          <Button size="small" color="error" onClick={() => items.removeItem.run(items.editItem.item || { item_id: -100 } as any)}>удалить</Button>
        </>}
      >
        {!!items.editItem.item &&
          <FormGrid columns="1fr" noMargin>
            <FormControlsForFields
              data={items.editItem.item}
              onChange={(o,c) => items.editItem.update(c)}
              fields={[
                ["author", { controlProps: { autoFocus: true }}],
                ["is_unlisted_author"],
                ["title"],
                ["subtitle"],
                ["item_format"],
                ["page_nbr"],
                ["page_nbr_display"],
              ]}
              schema={items.schema}
              errors={items.editItem.errors}
              />
          </FormGrid>}

      </SimpleDialog>


      <SimpleDialog
        dialogTitle="Импорт"
        noFullscreen
        submitOnModEnter
        {...items.importItems.dialog}
        save={() => items.importItems.save()}
      >
        {!!items.importItems.item &&
          <FormGrid columns="1fr" noMargin>
            <Typography>вставьте данные из Excel в поле ниже (порядок колонок: автор, название, подзаголовок, формат, страница)</Typography>
            <FormControlsForFields
              data={items.importItems.item}
              onChange={(o,c) => items.importItems.update(c)}
              fields={[
                ["items_text", { controlProps: { autoFocus: true }}],
              ]}
              schema={{ items_text: { type: FieldType.textlong, label: " "}}}
              />
          </FormGrid>}

      </SimpleDialog>
    </Form>
  );
}
